import request from '@/utils/request'

let InsuranceApi = {

  /*保险列表*/
  list(data) {
    return request._post('/shop/plus.insurance.Index/index', data);
},
/*添加保险*/
add(data) {
    return request._post('/shop/plus.insurance.Index/add', data);
},
/*修改保险*/
edit(data) {
    return request._post('/shop/plus.insurance.Index/edit', data);
},
/*删除保险*/
del(data) {
    return request._post('/shop/plus.insurance.Index/del', data);
},
/*保险详情*/
detail(data) {
  return request._post('/shop/plus.insurance.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.insurance.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.insurance.Setting/getSetting', data, errorback);
    },
}
export default InsuranceApi;



// WEBPACK FOOTER //
// ./src/api/insurance.js